<template>
    <div
        class="search-result"
        :class="{ isActive: id === activeId}"
        @click.prevent="$emit('click', resultUrl(data.id))"
    >
        <div class="text">
            {{ data.name }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchResultProduct',
    props: {
        data: {
            type: Object,
            default: () => {
                return null
            }
        },
        id: {
            type: Number,
            default: () => {
                return null
            }
        },
        activeId: {
            type: Number,
            default: () => {
                return null
            }
        }
    },
    emits: ['click'],
    created () {
        window.addEventListener('keydown', this.handleKeys)
    },
    unmounted () {
        window.removeEventListener('keydown', this.handleKeys)
    },
    methods: {
        resultUrl (productId) {
            return this.$route('products.products.show', {
                product: productId
            })
        },
        handleKeys (event) {
            // ENTER
            if (event.code === 'Enter') {
                this.$emit('click', this.resultUrl(this.data.id))
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.search-result {
    padding: 15px 25px;
    transition: 0.2s ease-in-out all;
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
    text-decoration: none;

    &:hover {
        background: rgba(0,0,0,0.07);
        cursor: pointer;
    }

    & .text {
        color: rgba(0,0,0,0.6);
    }
}
.isActive {
    background: rgba(0,0,0,0.07);
}
</style>
